import { ListPlus } from '@tamagui/lucide-icons';
import { EventView } from '@unistocks/features/dashboard/components/dashboard-data/event-view/event-view';
import { EventViewLayout } from '@unistocks/features/dashboard/components/dashboard-data/event-view/layout';
import { queryFilter } from '@unistocks/features/dashboard/components/dashboard-data/event-view/query-filter';
import {
  EventViewSettingsContentStep,
  EventViewSettingsLayoutStep,
  eventViewSchemaFactory
} from '@unistocks/features/dashboard/components/dashboard-data/event-view/settings';
import { DashboardItemDescriptor } from '@unistocks/features/dashboard/dashboard-item-descriptor';

export const dashboardItemDescriptor: DashboardItemDescriptor = {
  component: EventView,
  settingsSteps: [EventViewSettingsContentStep, EventViewSettingsLayoutStep],
  schemaFactory: eventViewSchemaFactory,
  defaults: setValue => {
    setValue('layout', EventViewLayout.List);
  },
  queryFilter: queryFilter,
  icon: ListPlus
};
